import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { DeleteManifestHistoryRouteBulkResponse, MutationDeleteManifestHistoryBulkArgs } from '@/models/gen/graphql';

import DeleteManifestHistoryRouteBulk from '@/features/DriveTimeTool/api/queries/DeleteManifestHistoryRouteBulk';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = string[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteManifestHistoryRouteBulkResponse>;
}

// DeleteManifestHistoryRouteBulk Service
export const { deleteManifestHistoryRouteBulk } = ((): {
  deleteManifestHistoryRouteBulk: ServiceMethod;
} => {
  const [, refetch] = graphApi(DeleteManifestHistoryRouteBulk).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteManifestHistoryRouteBulkResponse> => {
        const args: MutationDeleteManifestHistoryBulkArgs = {
          input: {
            search: payload.map((id) => ({ id })),
          },
        };
        const opts = { merge: options?.merge ? 'deleteManifestHistoryRouteBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteManifestHistoryRouteBulk', res);
      }
  );
  return {
    deleteManifestHistoryRouteBulk: refetch,
  };
})();
